import * as type from './types'
import { filterService } from '@/_services'
import { filterHelper } from '@/_helpers'

const actions = {
  setResourceFacets ({ commit }, { query, index, facet, urlFacets = null, checkedFacets = null, filters = null, defaultValues, rangeFilters }) {
    if (defaultValues != null) {
      const facetData = defaultValues.map((facetValues) => { return { ...facetValues, isChecked: false, facetQuery: null, facet } })
      if (urlFacets != null) {
        urlFacets.forEach((oldFacetValues) => {
          const index = facetData.findIndex(({ value, facet }) => {
            return oldFacetValues.value === value && facet === oldFacetValues.facet.split('=')[1]
          })
          if (index >= 0) {
            facetData[index] = { ...facetData[index], isChecked: true }
          }
        })
      } else if (checkedFacets !== null) {
        checkedFacets = checkedFacets.filter(({ isChecked }) => isChecked)
        checkedFacets.forEach((oldFacetValues) => {
          const index = facetData.findIndex(({ value, facet }) => {
            return oldFacetValues.value === value && facet === oldFacetValues.facet
          })
          if (index >= 0) {
            facetData[index] = { ...facetData[index], isChecked: true }
          }
        })
      }
      facetData.sort((a, b) => b.isChecked - a.isChecked)
      commit(type.SET_RESOURCE_FACETS, { facet, facetData: facetData })
    } else {
      // removed same facet filtering
      const removedSameFacetValuesFromFiltering = filters.filter(({ type }) => type !== facet)
      filterService[index]({ query, facet, filters: removedSameFacetValuesFromFiltering, rangeFilters }).then((values) => {
        return filterHelper.mapFacetValues({ values, facet, urlFacets, checkedFacets })
      }).then(({ facet, facetData }) => {
        commit(type.SET_RESOURCE_FACETS, { facet, facetData: facetData })
      })
    }
  },
  setCheckedFacet ({ commit }, { item, facet, index }) {
    commit(type.SET_CHECKED_FACET, { item, facet, index })
  },
  setFilterQuery ({ commit }, { queryArrayFacet, queryPage, querySearchText, queryRefSearch, queryNumericFilter, queryRangeFilter }) {
    commit(type.SET_QUERY_ARRAY_FACETS, { queryArrayFacet })
    commit(type.SET_QUERY_NUMERIC_FILTER, { queryNumericFilter })
    commit(type.SET_QUERY_RANGE_FILTER, { queryRangeFilter })
    commit(type.SET_QUERY_PAGE, { queryPage })
    commit(type.SET_QUERY_SEARCH_TEXT, { querySearchText })
    commit(type.SET_QUERY_SEARCH_REF, { queryRefSearch })
  },
  setResourceFacetsFromUrl ({ commit }, { url }) {
    Object.keys(url).forEach((key) => {
      if (key.includes('refinementList=')) {
        const facet = key.split('=')[1]
        const facetData = url[key].split('~').map((val) => ({
          value: val,
          count: 1,
          isChecked: true,
          facetQuery: null,
          facet: facet
        }))
        commit(type.SET_RESOURCE_FACETS, { facet, facetData: facetData })
      }
    })
  },
  setTextFieldSearchFilter ({ commit }, { query }) {
    commit(type.SET_SEARCH_QUERY, { query })
  },
  setTextFieldSearchReferenceFilter ({ commit }, { index, query }) {
    commit(type.SET_REFERENCE_QUERY, { query })
    // if (query != null) {
    //   if (query.length > 0) {
    //     filterService[index]({ reference: query }).then((response) => {
    //       commit('SET_RESOURCE_LIST', { items: [response] })
    //     }).catch((error) => {
    //       console.error(error)
    //     })
    //   }
    // }
  },
  setWrldDateFilter ({ commit }, { attribute, value }) {
    commit(type.SET_DATE_FILTER, { attribute, value })
  },
  setWrldRangeFilter ({ commit }, { attribute, value }) {
    commit(type.SET_RANGE_FILTER, { attribute, value })
  },
  clearFilterFacetValue ({ commit }, { index, facetValue, facetsArray }) {
    commit(type.CLEAR_FILTER_FACET_VALUE, { facet: facetValue.facet, value: facetValue.value })
    commit(type.CLEAR_SPECIFIC_FACET_VALUE, { facet: facetValue.facet, value: facetValue.value })
    Object.keys(facetsArray).forEach((facet) => {
      filterService[index]({ facet }).then((values) => {
        let checkedFacets = facetsArray[facet].filter(({ isChecked }) => isChecked)
        if (facetValue.facet === facet) {
          const facetValueIndex = checkedFacets.findIndex(({ value, facet }) => {
            return value === facetValue.value
          })
          if (facetValueIndex >= 0) {
            checkedFacets.splice(facetValueIndex, 1)
          }
        }
        return filterHelper.mapFacetValues({ values, facet, checkedFacets })
      }).then(({ facet, facetData }) => {
        commit(type.SET_RESOURCE_FACETS, { facet, facetData: facetData })
      })
    })
  },
  clearFilterRangeValue ({ commit  }, { rangeType }) {
    commit(type.CLEAR_RANGE_FILTER, { rangeType })
  },
  clearAllFilters ({ commit }, { index, facetsArray, notClearable }) {
    facetsArray.forEach((facet) => {
      filterService[index]({ facet }).then((values) => {
        return filterHelper.mapFacetValues({ values, facet })
      }).then(({ facet, facetData }) => {
        commit(type.SET_RESOURCE_FACETS, { facet, facetData: facetData })
      })
    })
    commit(type.CLEAR_ALL_FILTERS, { notClearable })
  },
  setResourceIndex({ commit }, { index }) {
    commit(type.SET_RESOURCE_INDEX, { index })
    commit(type.CLEAR_ALL_FILTERS, { notClearable: [] })
  }
}
export default actions
